export default __webpack_public_path__ + "media/images/Masto-A2-Linux-Pingouin-adcd212d5748a1d1240f31813325337a.png";